(function($, w) {
  'use strict';

  function initMagPopupClass(e) {
    e.preventDefault();

    $(".mfp-bg").addClass('animated fade-in-200');
    $(".mfp-content").addClass('animated fade-in-400');

    // focus on input automatically
    setTimeout(()=> {
      document.querySelector('.modal--search input[type="search"]').focus();
    }, 300)

  }

  $(".js-modal--search-trigger").magnificPopup({
    type: 'inline',
    closeBtnInside: true,
    mainClass: 'animated',
    closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close search modal"><img class="mfp-close" src="/themes/custom/loomis/dist/images/icon-close-white.svg" /></button>'
  });

  $(".js-modal--search-trigger").on('click', initMagPopupClass);

  $(".js-magpopup-video").magnificPopup({
    type: 'iframe',
    closeBtnInside: true,
    fixedContentPos: false,
    mainClass: 'animated',
  });

  $(".js-magpopup-video").on('click', initMagPopupClass);

})(jQuery, window);
